<template>
    <div id="app">
        <div v-if="!loading" class="d-md-flex application">
            <main class="column-left">
                <CompanyDetails />
                <CheckoutForm v-if="checkout">
                    <slot />
                </CheckoutForm>
                <ProductList v-else/>
                <small class="credits">
                    <a
                        target="_blank"
                        href="https://www.heerlijkinhuis.nl"
                        rel="nofollow noreferrer noopener"
                    >
                        <img src="/images/credits/logo-grey.svg" alt="">
                    </a>

                    <span class="credits-initiatives">
                        is een initiatief van
                        <a
                            target="_blank"
                            href="https://www.23g.nl?source=heerlijkinhuis"
                            rel="noreferrer noopener"
                            class="ml-3 text-decoration-none"
                        >
                            <img src="/images/credits/23g-logo.svg" alt="">
                        </a>
                        <a
                            target="_blank"
                            href="https://www.heerlijk.nl?source=heerlijkinhuis"
                            rel="nofollow noreferrer noopener"
                            class="ml-3 text-decoration-none"
                        >
                            <img src="/images/credits/heerlijk-logo.svg" alt="">
                        </a>
                    </span>
                </small>
            </main>
            <aside class="column-right">
                <ShoppingCart />
            </aside>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import CheckoutForm from '@/components/checkout/Form';
    import CompanyDetails from '@/components/company/Details';
    import ProductList from '@/components/products/List';
    import ShoppingCart from '@/components/products/Cart';

    export default {
        components: {
            CheckoutForm,
            ProductList,
            ShoppingCart,
            CompanyDetails,
        },
        computed: {
            ...mapState({
                loading: state => state.products.loading,
                checkout: state => state.cart.checkout,
            }),
        },
        async created() {
            await this.$store.dispatch('products/getRestaurant');
        },
    };
</script>

<style lang="scss">
    .application {
        max-width: 1450px;
        min-height: 100vh;
        padding: 18px 18px;
        margin: 0 auto;

        @include respond-to(md) {
            padding: 36px 18px;
        }
    }

    .column {
        &-left {
            flex: 1 0 0;

            @include respond-to(md) {
                flex: 1 0 calc(100% - 336px);
                max-width: calc(100% - 336px);
                margin: 0 18px;
            }
        }

        &-right {
            @include respond-to(md) {
                flex: 1 0 300px;
                max-width: 300px;
                margin: 0 18px;
            }
        }
    }

    .credits {
        display: flex;
        flex-flow: column wrap;
        align-items: center;
        justify-content: center;
        margin: 20px 0 0;
        color: $silver-chalice-2;

        @include respond-to(md) {
            flex-flow: row wrap;
            justify-content: space-between;
        }

        &-initiatives {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 20px;

            @include respond-to(md) {
                margin-top: 0;
            }
        }
    }
</style>
